import { Navigate, useParams } from 'react-router';
import { FileUploadTabNames } from 'src/data-capture/file-management/FileUploadPage';
import FamilyAddDocumentsPage from './FamilyAddDocumentsPage';
import FamilyFilesPage from './FamilyFilesPage';
import FamilyGeneratedDocuments from './FamilyGeneratedDocuments';

type FileUploadTabName = (typeof FileUploadTabNames)[keyof typeof FileUploadTabNames];

function isTabName(value?: string): value is FileUploadTabName {
  if (!value) return false;
  return Object.values(FileUploadTabNames).includes(value as FileUploadTabName);
}

export default function FamilyFileUploadPage() {
  const {
    familyId,
    sectionSlug: tab,
    folderId,
  } = useParams<{
    familyId: string;
    sectionSlug?: string;
    folderId?: string;
  }>();

  const isFolderRoute = tab?.startsWith('folder/') || !!folderId;
  const selectedTab = isFolderRoute ? FileUploadTabNames.Reviewed : tab;
  const fallback = `/family/${familyId}/documents/${FileUploadTabNames.ToReview}`;

  if (!isFolderRoute && !isTabName(selectedTab)) {
    return <Navigate to={fallback} replace />;
  }

  switch (selectedTab) {
    case FileUploadTabNames.ToReview:
    case FileUploadTabNames.ToReviewFromOneDrive:
      return <FamilyAddDocumentsPage />;
    case FileUploadTabNames.Reviewed:
      return <FamilyFilesPage />;
    case FileUploadTabNames.SuitabilityReports:
      return <FamilyGeneratedDocuments documentTypeFilter="suitability-report" />;
    case FileUploadTabNames.MeetingAgendas:
      return <FamilyGeneratedDocuments documentTypeFilter="meeting-agenda" />;
    case FileUploadTabNames.MeetingNotes:
      return <FamilyGeneratedDocuments documentTypeFilter="meeting-note" />;
    case FileUploadTabNames.DataExports:
      return <FamilyGeneratedDocuments documentTypeFilter="data-export" />;
    case FileUploadTabNames.SiestaAIGenerated:
      return <FamilyGeneratedDocuments />;
    default:
      return <Navigate to={fallback} replace />;
  }
}
